// Composes the full "U.S. <Branch>" display label from a raw branch id/name.
// Accepts either a canonical branch id (army, airforce, ...) or a looser
// variant (case/whitespace/punctuation) and normalizes both.
export function normalizeBranch(branch) {
  if (!branch) return '';
  const key = String(branch).trim().toLowerCase().replace(/[-\s.]/g, '');
  const map = {
    airforce:    'U.S. Air Force',
    usaf:        'U.S. Air Force',
    army:        'U.S. Army',
    usarmy:      'U.S. Army',
    navy:        'U.S. Navy',
    usnavy:      'U.S. Navy',
    marines:     'U.S. Marine Corps',
    marinecorps: 'U.S. Marine Corps',
    usmc:        'U.S. Marine Corps',
    spaceforce:  'U.S. Space Force',
    ussf:        'U.S. Space Force',
    coastguard:  'U.S. Coast Guard',
    uscg:        'U.S. Coast Guard',
  };
  return map[key] || branch;
}
